import { AssetCreationToolName, GenerationInstrument } from '@/types/media';
import { CreditsPriceItem, FreePriceItem } from './CreditsBillingService';

const DEFAULT_PRICES: Record<GenerationInstrument, CreditsPriceItem | typeof FreePriceItem> = {
  [GenerationInstrument.textToImage]: CreditsPriceItem.imageGenerationPrice,
  [GenerationInstrument.textToVideo]: CreditsPriceItem.videoGenerationPrice,
  [GenerationInstrument.textToAudio]: CreditsPriceItem.audioGenerationPrice,
  [GenerationInstrument.imageToImage]: CreditsPriceItem.imageGenerationPrice,
  [GenerationInstrument.chatToImage]: CreditsPriceItem.imageGenerationPrice,
  [GenerationInstrument.imageToVideo]: CreditsPriceItem.videoGenerationPrice,
  [GenerationInstrument.tryOnImage]: CreditsPriceItem.imageGenerationPrice,
};

/**
 * Overrides a default price for a tool.
 */
const TOOLS_CUSTOM_PRICES = new Map<AssetCreationToolName, typeof DEFAULT_PRICES>();

export class MediaAssetToolsPrices {
  public static isToolName(name: string): boolean {
    return Object.values(AssetCreationToolName).includes(name as AssetCreationToolName);
  }

  public static getPriceItems(
    toolName: AssetCreationToolName,
    instrumentsUsed: GenerationInstrument[]
  ): CreditsPriceItem[] {
    if (!instrumentsUsed.length) return [];

    return instrumentsUsed.reduce((acc: CreditsPriceItem[], instrument) => {
      const toolsOverrides = TOOLS_CUSTOM_PRICES.get(toolName);
      const instrumentPrice = toolsOverrides?.[instrument] ?? DEFAULT_PRICES[instrument];
      if (instrumentPrice !== FreePriceItem) {
        acc.push(instrumentPrice);
      }

      return acc;
    }, []);
  }
}
